module.exports = __webpack_public_path__ + "img/1.49ad7036.png";